// extracted by mini-css-extract-plugin
export default {"root":"SectionPicker_root__0kbl4","arrBtn":"SectionPicker_arrBtn__zJX8E","icon":"SectionPicker_icon__Pq+uY"};